import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "listing-block__controls" }
const _hoisted_3 = { class: "listing-block__title" }
const _hoisted_4 = { class: "listing-block__button" }

import { PropType } from "vue";
import { IProductContentTile } from "@/models/IProductContentTile";
import TressResponsivePicture from "@/components/TressResponsivePicture.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressProductContentTile',
  props: {
  tile: {
    type: Object as PropType<IProductContentTile>,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_icon_arrow_right = _resolveComponent("icon-arrow-right")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'col-12 col-md-8 col-xl-6 col-xxl-2-5': __props.tile.showAsDouble,
      'col-6 col-md-4 col-xl-3 col-xxl-2-4': !__props.tile.showAsDouble,
      'product-listings__container--no-border': (__props.index + 1) % 2 == 0,
      'product-listings__container--no-border-md': (__props.index + 1) % 3 == 0,
      'product-listings__container--no-border-xl': (__props.index + 1) % 4 == 0,
      'product-listings__container--no-border-xxl': (__props.index + 1) % 5 == 0,
    }, "col product-listings__container"])
  }, [
    _createElementVNode("a", {
      href: __props.tile.url,
      class: "listing-block"
    }, [
      _createVNode(TressResponsivePicture, {
        class: "listing-block__image",
        pictures: __props.tile.image
      }, null, 8, ["pictures"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(__props.tile.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_icon_arrow_right)
        ])
      ])
    ], 8, _hoisted_1)
  ], 2))
}
}

})